import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api from "../api";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 10) return toast.error("Password must be at least 10 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/accept-invite", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (err) {
      toast.error(err.message || "Could not set password");
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
        <p className="text-slate-300 text-sm">Invalid invite link.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-sm sgp-card p-6 space-y-4">
        <div className="flex flex-col items-center text-center gap-2">
          <KeyRound className="h-8 w-8 text-teal-600" />
          <h1 className="font-heading font-bold text-lg">Set your password</h1>
          <p className="text-xs text-slate-500">Choose a password with at least 10 characters.</p>
        </div>
        {done ? (
          <p className="text-sm text-teal-700 text-center">Password set. Redirecting to sign in…</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="sgp-label">New password</label>
              <input type="password" required className="sgp-input" value={password}
                onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div>
              <label className="sgp-label">Confirm password</label>
              <input type="password" required className="sgp-input" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} />
            </div>
            <button type="submit" disabled={busy}
              className="w-full h-10 rounded-md bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold disabled:opacity-60 transition-colors">
              {busy ? "Saving…" : "Set password & continue"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
